import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { BlendEvent, SHARE_DETAILS_OPEN_STATE } from 'src/app/shared/models';
import { ShareService } from 'src/app/shared/services/share.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { IErrorCode, IShareData, ISharememberData, ISharememberInviteData } from 'src/sync';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { BlendService } from 'src/app/shared/services/blend.service';
type PermissionKey = 'perUPLOAD' | 'perSEEOTHERS' | 'perADDAPP' | 'perOWNER' | 'perINVITE';

@Component({
  selector: 'app-share-permission',
  templateUrl: './share-permission.component.html',
  styleUrls: ['./share-permission.component.scss']
})
export class SharePermissionComponent implements OnInit, OnDestroy {
  @Input() public shareData: IShareData;
  @Input() public openState: number;
  @Output() openStateChange: EventEmitter<number> = new EventEmitter();
  @Input() showDialog!: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isPro!: number;
  email: string = '';
  name: string = '';
  public spinners = {
    member: 0,
  };
  public errors: Array<IErrorCode> = [];
  public spinner: boolean=false;
  members: ISharememberData[] = []
  public sharemember: ISharememberInviteData = {
    permissions: {
      perDOWNLOAD: 1,
      perUPLOAD: 0,
      perINVITE: 0,
      perSEEOTHERS: 0,
    },
    displayName: '',
    queue: [],
    roleQueue: [],
    roleName: '',
    privateMessage: '',
  };
  public isSmallScreen: boolean = false;
  private breakpointSubscription: Subscription;

  constructor(
    private loggerService: LoggerService,
    private userService: UserService,
    public breakpointObserver: BreakpointObserver,
    private shareService: ShareService,
    private snackbarService: SnackbarService,
    private blendService: BlendService
  ) { }
  async ngOnInit() {
    this.breakpointSubscription = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  
    this.showDialog = true;
    this.isPro = this.userService.get('is_pro');

    // await this.getShareDetails()
    if (!this.shareData) {
      this.loggerService.error(
        'Unable to find shareData for sharemember-list'
      );
    }
    this.name = this.shareData['name'];
    this.shareData.people.forEach((cur) => {
      if (cur.selected) {
        this.members.push(cur);
      }
    });
    const member: ISharememberData = this.members[0];
    this.email = member['email'];
    this.sharemember.permissions = { ...member.permissions }
    console.log('sharemember', this.sharemember, member, this.shareData);
  }

  ngOnDestroy(): void {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  permissionChanged(checked: boolean, permission: 'perUPLOAD' | 'perSEEOTHERS' | 'perADDAPP' | 'perOWNER' | 'perINVITE') {
    this.sharemember.permissions[permission] = checked ? 1 : 0;
  }
  private openPopup(state: number) {
    this.openStateChange.next(state);
  }
  onCheckCanEditChange = (env) => {
    const checked = env['checked']
    this.permissionChanged(checked, 'perUPLOAD')
  }
  onCheckCanInviteChange = (env) => {
    const checked = env['checked']
    this.permissionChanged(checked, 'perINVITE')
  }
  onCheckCanSeeOthersChange = (env) => {
    const checked = env['checked']
    this.permissionChanged(checked, 'perSEEOTHERS')
  }

  onSave = () => {
    const permissions:any = {}
    for (const permission in this.sharemember.permissions) {
      if (Object.prototype.hasOwnProperty.call(this.sharemember.permissions, permission)) {
        const val = this.sharemember.permissions[permission];
        if (typeof val == 'number') {
          console.log(val, permission);
          permissions[permission] = val;
        }
      }
    }
    console.log('sharemember', this.sharemember, this.shareData, permissions);
    this.updatePermissions(permissions)

  }
  updatePermissions = async (permissions:{
    perUPLOAD: number;
    perSEEOTHERS: number;
    perADDAPP: number;
    perOWNER: number;
    perINVITE: number;
  }) => {
    const tasks = [];
    for (const permission in permissions) {
      if (Object.prototype.hasOwnProperty.call(permissions, permission)) {
        const value = permissions[permission as PermissionKey];
        const permissionKey = permission as PermissionKey;
        const sharemember = this.members[0];
        const newVal = !value ? 1 : 0;
        sharemember.permissions[permission] = newVal;
        await this.shareService.setPermission(
          this.shareData,
          permissionKey,
          sharemember
        );
      }
    }
    Promise.all(tasks)
      .then(() => {
        console.log('All tasks completed');
        this.onBack();
      this.snackbarService.showMessage('success', `Permissions successfully saved.`)

      this.blendService.track(BlendEvent.UPDATE_SHARE_PERMISSIONS, {
        upload: !!permissions.perUPLOAD,
        invite: !!permissions.perINVITE,
        see_others: !!permissions.perSEEOTHERS,
        add_apps: !!permissions.perADDAPP,

      });
      })
      .catch(error => {
        console.error('One or more tasks failed:', error);
        this.onBack();
        this.snackbarService.showMessage('critical', 'Couldn’t complete action. Try again.');
      });
  }
  closeDialog = (state: number = SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(state > 0 ? true : false);
      this.openPopup(state)
    }, 50);
  }
  onBack = () => {
    console.log('onBack options', 5);
    this.closeDialog(SHARE_DETAILS_OPEN_STATE.MEMBER_LIST);
  }
}
